module.exports = __webpack_public_path__ + "static/media/address.d1d61733.jpg";